module.exports = __webpack_public_path__ + "officialStatic/img/logo25.8e5dd4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/logo25.png
// module id = b4Mi
// module chunks = 0